'use strict';

module.exports = function isValidUserToken(userToken) {
  if (userToken === null) {
    return false;
  }

  return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};